import { render, staticRenderFns } from "./ForestCard.vue?vue&type=template&id=3c1d96c5&scoped=true&lang=pug"
import script from "./ForestCard.vue?vue&type=script&lang=js"
export * from "./ForestCard.vue?vue&type=script&lang=js"
import style0 from "./ForestCard.vue?vue&type=style&index=0&id=3c1d96c5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d96c5",
  null
  
)

export default component.exports